import uploadImage from '../assets/upload.png';
import companyAvatar from '../assets/companyAvatar.png';
import userAvatar from '../assets/userAvatar.png';
import appLogo from '../assets/mediosis-logo.png';
import LoginBg from '../assets/buskes_login-bg.png';
import categoryAvatar from '../assets/categoryAvatar.png';
import foodMenuAvatar from '../assets/foodMenuAvatar.png';

export const ImageUtil = {
    uploadImage,
    companyAvatar,
    userAvatar,
    appLogo,
    LoginBg,
    categoryAvatar,
    foodMenuAvatar
};
